import { ApiRequestError } from '@/lib/api';
import type { TranslationKey } from '@/i18n/translations';

/**
 * Тексты отказов берём по коду ответа: сервер пишет их по-русски и языка интерфейса не знает.
 * Показывать `err.message` на английском экране значило бы вставить туда русскую фразу.
 */
function errorCode(err: unknown): string | undefined {
  return err instanceof ApiRequestError ? err.code : undefined;
}

export function resendErrorKey(err: unknown): TranslationKey {
  return errorCode(err) === 'RESEND_TOO_MANY' ? 'verify.resendTooMany' : 'login.resendError';
}

export function verifyCodeErrorKey(err: unknown): TranslationKey {
  switch (errorCode(err)) {
    case 'VERIFY_INVALID':
      return 'verify.invalidCode';
    case 'VERIFY_TOO_MANY_ATTEMPTS':
      return 'verify.tooManyAttempts';
    default:
      return 'verify.submitError';
  }
}

/** Сбой сети или сервера — не повод говорить, что ссылка недействительна: она может быть рабочей. */
export function verifyLinkErrorKey(err: unknown): TranslationKey {
  switch (errorCode(err)) {
    case 'VERIFY_INVALID':
      return 'verify.linkInvalid';
    case 'VERIFY_TOO_MANY_ATTEMPTS':
      return 'verify.tooManyAttempts';
    default:
      return 'verify.linkCheckFailed';
  }
}
